import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { NgClass, NgIf } from '@angular/common';
import { Apps } from '../../interfaces/apps.interface';
import { environment } from '../../environments/environment';
import { DialogService } from '../../services/dialog.service';
import { Validators } from '@angular/forms';

@Component({
  selector: 'wm-libs-telegram-bot',
  templateUrl: './telegram-bot.component.html',
  standalone: true,
  imports: [NgIf, MatButtonModule, NgClass, RouterLink, RouterLinkActive, TranslateModule],
})
export class TelegramBotComponent {
  @Input() app!: Apps;
  @Input() telegramVerified!: boolean | undefined;

  @Output() telegramBotVerified = new EventEmitter<string>();

  env = environment;

  telegramBotUrl!: string;

  constructor(private dialogService: DialogService) {}

  openConnectTgBot() {
    this.telegramBotUrl = this.app === 'wm-tech-pool' ? environment.poolTelegramBotUrl || '' : environment.mmsTelegramBotUrl || '';

    const config = {
      image: 'assets/images/settings/telegram.png',
      imageAlt: 'telegram bot',
      title: 'WM_TECH_POOL.SETTINGS.TELEGRAM_BOT.DIALOG.TITLE',
      app: 'tech',
      submitLabel: 'WM_TECH_POOL.SETTINGS.TELEGRAM_BOT.DIALOG.CONNECT',

      fields: [
        {
          type: 'paragraph',
          label: 'WM_TECH_POOL.SETTINGS.TELEGRAM_BOT.DIALOG.DESCRIPTION',
        },
        {
          type: 'paragraph-link',
          paragraphLabel: 'WM_TECH_POOL.SETTINGS.TELEGRAM_BOT.DIALOG.LINK1',
          linkLabel: 'WM_TECH_POOL.SETTINGS.TELEGRAM_BOT.DIALOG.LINK2',
          link: this.telegramBotUrl,
        },
        {
          type: 'qr',
          qrUrl: this.telegramBotUrl,
        },

        {
          name: 'tgCode',
          label: 'WM_TECH_POOL.SETTINGS.TELEGRAM_BOT.DIALOG.CODE',
          type: 'input',
          mask: this.app === 'wm-tech-pool' ? '000000' : '00000',
          inputSize: 'small',
          validators: [Validators.required],
        },
      ],
    };

    const dialogRef = this.dialogService.openPopup(config);

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.tgCode) {
        this.telegramBotVerified.emit(result?.tgCode);
      }
    });
  }
}
